// extracted by mini-css-extract-plugin
module.exports = {"similarVenuesContainer":"_2XU8uLPivZjRczG5Qy6SnN","similarVenueCards":"_1H1M87wu3PXFNY3B8pSafH","venueContainer":"_3Kw9QXiMpxh44jKrEYc8_R"};